import axios from 'axios';

import { apiUrl, config } from '../Shared/config';


// let source = axios.CancelToken.source();


export const getGroups = async () => {
  try {
    const { data } = await axios.get(apiUrl + 'reporting/groups', config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getLocations = async (userId = null, groupId = null) => {
  try {
    const { data } = await axios.get(apiUrl + 'reporting/locations' + (
      userId && groupId ? `/user=${userId}&group=${groupId}` : ''
    ), config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};

// let cancelToken = null;
export const getDeployments = async ({ mode, scenario, module, startDate, endDate, groups, locations, offset, size }) => {

  //  console.log("30 - ...........................................................................", cancelToken);
  // console.log("30 - mode=", mode);
  // console.log("31 - scenario=", scenario);
  // console.log("32 - module=", module);
  // console.log("33 - startDate=", startDate);
  // console.log("34 - endDate=", endDate);

  // source.cancel("...");

  // if (cancelToken !== null) {
  //   cancelToken.cancel("Operation canceled due to new request.")
  // }

  //Save the cancel token for the current request
  // cancelToken = axios.CancelToken.source()

  const configTmp = {
    ...config,
    // cancelToken: cancelToken.token,
    // onUploadProgress: function (progressEvent) {
    //   // Do whatever you want with the native progress event
    //   // console.log("54 - progressEvent=", progressEvent);
    // },
    // onDownloadProgress: function (progressEvent) {
    //   // Do whatever you want with the native progress event
    //   // console.log("58 - progressEvent=", progressEvent);
    // },
  }

  try {
    const { data } = await axios.post(apiUrl + 'reporting/deployments', {
      mode, scenario, module, startDate, endDate, groups, locations, offset, size
    }, configTmp);

    // console.log("49 - getDeployments=", data.success);

    // cancelToken = null;
    return data.success ? data : data?.error;

  } catch (error) {
    // console.log("54 - getDeployments=", error);

    // cancelToken = null;
    return error.response?.data?.error || 'error';
  }
};


export const getRealtimeDeployments = async (locations) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/realtime', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getDeploymentsHistory = async (deployment, usage = 0) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/deployments/history', { deployment, usage }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getReports = async () => {
  try {
    // console.log("103 - getReports...");
    const { data } = await axios.post(apiUrl + 'reporting/reports', {}, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getReportGenerated = async (deployment, usage = 0, selectedReport) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/deployments/reportgenerator', { deployment, usage, selectedReport }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};

export const getMultiReportGenerated = async (deploymentIdsList, locationId, selectedReport, devicesType) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/deployments/multireportgenerator', { deploymentIdsList, locationId, selectedReport, devicesType}, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};

export const getMultiReportArchiveGenerated = async (mapDeploymentIdsList, selectedReport, devicesType) => {
  try {   
    const { data } = await axios.post(apiUrl + 'reporting/deployments/multireportarchivegenerator', { mapDeploymentIdsList, selectedReport, devicesType}, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};

export const getMultiReportArchiveGeneratedStatus = async (archiveCode) => {
  try {   
    const { data } = await axios.post(apiUrl + 'reporting/deployments/multireportarchivegeneratorstatus', { archiveCode}, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};





export const getWelcomeScreenManualInputs = async ({ locations }) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/welcomeScreenManualInputs', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getSDSQuestions = async ({ locations }) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/sdsquestions', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getScriptHeaders = async ({ locations }) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/scriptHeaders', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getMobileOthersData = async ({ locations }) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/mobileOthersData', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getExtDiskHealthAndPerf = async ({ locations }) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/sdsExtDiskHealthAndPerf', { locations }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};